import Channel from "controllers/channel";
import { Modal } from "antd";
import store from "data/store";

class PremiumsService {
  init = () => {
    this.channel = new Channel(
      { channelName: "Contact::PremiumPurchaseChannel" },
      { received: this._handleChannelReceived }
    );
  };

  _handleChannelReceived = (data) => {
    const { action, message } = data;

    if (action === "added") this._handlePremiumAdd(message);
    if (action === "sold") this._handlePremiumSold(message);
  };

  _handlePremiumAdd = (data) => {
    const chat = store.byId(data.chatRoomId);

    if (chat) {
      chat.contact.addPremiumPurchase(data);
    }
  };

  _handlePremiumSold = (data) => {
    const chat = store.byId(data.chatRoomId);

    if (chat) {
      chat.contact.updatePremiumPurchase(data);
    }

    this._showSoldModal(data);
  };

  _showSoldModal = (data) => {
    const { contact, title } = data;

    Modal.success({
      title: "Successful sale",
      content: `${contact.firstName || contact.id} purchased ${title}`,
    });
  };

  dispose = () => {
    this.channel.dispose();
  };
}

export default new PremiumsService();
